import { render, staticRenderFns } from "./AssignCourseAction.vue?vue&type=template&id=7be3c762"
import script from "./AssignCourseAction.vue?vue&type=script&lang=js"
export * from "./AssignCourseAction.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports